<section id="secao-caixa-numeros">
  <div class="container fundo-azul-escuro">
    <div class="row">
      <div class="col-6">
        <span class="material-icons icone"> school </span>
        <span class="caixa-numero">
          <span>
            <p>
              <strong class="numero">18</strong>
            </p>
          </span>
          <h5 class="sub">Empresas Graduadas</h5>
          <p class="sub-sub">+ R$ 244 milhões em 2024</p>
        </span>
      </div>
      <div class="col-6">
        <span class="material-icons icone"> house </span>
        <span class="caixa-numero">
          <span>
            <p>
              <strong class="numero">12</strong>
            </p>
          </span>
          <h5 class="sub">Empresas Incubadas</h5>
          <p class="sub-sub">+ R$ 1,8 milhões em 2024</p>
        </span>
      </div>
    </div>
  </div>
</section>
